
  import { Component, Prop, Vue } from "vue-property-decorator";
  import Tooltip from "@/components/common/Tooltip.vue";


  @Component({
    components: {
      Tooltip,
    },
  })
  export default class InvitationSentTooltip extends Vue {
    @Prop({type: Boolean, required: true}) readonly disabled!: boolean;
    @Prop({ type: Boolean, default: false }) readonly fullWidth!: boolean;
  }
